import { Helmet } from 'react-helmet-async';
// sections
import { TourGuideConfigurationView } from 'src/sections/tourGuide/view';

// ----------------------------------------------------------------------

export default function TourGuideConfigurePage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Configure tour guide</title>
      </Helmet>

      <TourGuideConfigurationView />
    </>
  );
}
